var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgTd = function SvgTd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000067",
    d: "M0 0h213.97v480H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M426.03 0H640v480H426.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "M213.97 0h212.06v480H213.97z"
  }))));
};
export default __webpack_public_path__ + "assets/8c0f4fcb2c1996669c144547d2521a26.svg";
export { SvgTd as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/td.svg